import React from "react"

import ReactTable from "react-table";


export default class ProductSection extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      ...this._getState(props)
    }

  }

  _getState(props){
    return {
      section: props.section,
      sections: props.section.sections,
    }
  }

  componentWillReceiveProps(props) {
    this.setState(this._getState(props))
  }

  render(){
    const {
      sections,
    } =  this.state

    const totalProductsNo = sections.length
    const pageSize = 10

    return (
      <>
        <ReactTable
          ref={this.reactTable}
          className={"product-section-table"}
          data={sections}
          totalRecords={totalProductsNo}
          columns={[
            {
              Header: '',
              id: 'name',
              Cell: rowInfo => {
                return this.props.renderSubSection(rowInfo.original, rowInfo.index)
              },
            },
          ]}
          sortable={false}
          resizable={false}
          showHeader={false}
          showPagination={true}
          showPaginationTop={true}
          showPaginationBottom={true}
          collapseOnDataChange={true}
          minRows={pageSize}
          defaultPageSize={pageSize}
        />
      </>
    )
  }
}
